<button class="" [hidden]="!testigo.correo_testigo.trim()" style="background: none; color: black; border: none;" matTooltip="{{'texto_461' | translate }}"
  type="button" rounded="true" data-toggle="modal" data-target="#basicExample" (click)="frame.show()" mdbWavesEffect><i
    class="fas fa-envelope"></i>
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document" style="max-width: 100% !important;">
    <!--Content-->
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 style="margin-bottom: 0px;" class="card-title">{{ 'texto_887' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <div class="row">
          <div class="col-md-12" style="margin-top: 1.2rem">
            <mat-label>
              {{ testigo.n_testigo?.trim() ? testigo.n_testigo : ('texto_888' | translate) }}
            </mat-label>
          </div>
          <div class='col-md-12' style="margin-top: 0.8rem">
            <div class="form-group">
              <label class="control-label">{{ 'texto_38' | translate }}</label> <br>
              <input type="email" class="form-control" formControlName="email" [value]="testigo?.correo_testigo || ''"
                (input)="onEmailInputChange($event)" placeholder="{{ 'texto_38' | translate }}" required>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="md-form mb-10 col-md-12">
            <mdb-icon fas icon="pencil-alt" class="prefix grey-text"></mdb-icon> <label class="control-label"
              for="infoEmail">{{ 'texto_39' | translate }}</label><br>
            <ngx-wig id="infoEmailReceptor" [(ngModel)]="infoEmail" [formControl]="myForm.get('infoEmail')"
              [buttons]="'bold, italic, link, underline'" (ngModelChange)="onEditorChange($event)"
              [attr.aria-invalid]="myForm.get('infoEmail').invalid ? 'true' : null"></ngx-wig>
            <span style="float: left;font-weight: bold;font-size: 0.75rem;">{{ charCount }} {{ 'texto_69' | translate }}
              {{ maxCharCount }}</span>
          </div>
        </div>
        <div class="text-center mt-3">
          <button [disabled]="isLoading || myForm.invalid || charCount === 0" (click)="enviarCorreo()" style="color:#fff" mdbBtn rounded="true" class="btn-primary mt-1 waves-light"
            mdbWavesEffect>{{ 'texto_461' | translate}}
          </button>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</div>